module.exports = __webpack_public_path__ + "images/partying-face-gif.gif";